import { AppState } from '@chegg-wt/core/state/types'
import { createSelector } from 'reselect'
import { formattedAutociteSource } from '../createCitation/helpers'
import { ValidatorStates } from './constants'

export const activeCitationSelector = (state: AppState) => state.citation.activeCitation
export const isNewCitationSelector = (state: AppState) => state.citation.isNew
export const validatorStatusSelector = (state: AppState) => state.citation.validatorStatus

// this looks like a dupe of a selector in /createCitation
export const createCitationSourceSelector = (state: AppState) =>
  state.createCitation.selectedSource

export const currentCitationSourceSelector = (state: AppState) =>
  formattedAutociteSource(state.citation.activeCitation.source)

export const currentCitationSourceTypeSelector = (state: AppState) =>
  state.createCitation.sourceType

export const citationInProgressSelector = (state: AppState) =>
  state.citation.citationInProgress

export const createCitationSourceDataSelector = (state: AppState) =>
  state.createCitation.selectedSource && state.createCitation.selectedSource.data

export const showErrorToastSelector = (state: AppState) => state.citation.showErrorToast

export const isValidCitationSelector = createSelector(
  [validatorStatusSelector],
  (validatorStatus): boolean => validatorStatus !== ValidatorStates.MISSING
)

export const mostRecentCitationIdSelector = createSelector(
  [isNewCitationSelector, activeCitationSelector],
  (isNew, activeCitation): string => (isNew && activeCitation.id ? activeCitation.id : '')
)

export const incompleteCitationIdSelector = createSelector(
  [isValidCitationSelector, activeCitationSelector],
  (isValidCitation, activeCitation): string =>
    !isValidCitation && activeCitation.id ? activeCitation.id : ''
)

export const shouldShowValidatorWarningSelector = createSelector(
  [incompleteCitationIdSelector],
  (incompleteCitationId): boolean => !!incompleteCitationId
)

export const isEditCitationSelector = createSelector(
  [activeCitationSelector],
  (activeCitation) => !!activeCitation?.citationId
)

export const activeCitationIdSelector = createSelector(
  [activeCitationSelector],
  (activeCitation) => activeCitation?.citationId
)

export const currentCitationAutociteRioTrackingIDSelector = (state: AppState) =>
  state.citation.autociteRioTrackingID

export const currentCitationAutociteResponseForRioSelector = (state: AppState) =>
  state.citation.autociteResponseForRio
